import React, { PropTypes } from 'react';
import idx from 'idx';
import first from 'lodash/first';
import tail from 'lodash/tail';
import last from 'lodash/last';
import classnames from 'classnames';
import Tooltip from 'react-tooltip';
import { isMobile } from 'common/utils';

const Comparison = ({ title, description, rows_html, background }) => {
  const comparing = first(rows_html);
  const restRows = tail(rows_html);
  return (
    <section className={classnames("block block-comparison", background)}>
      <div className="row columns">
        <div className="block-header">
          <h2>{title}</h2>
          <p className="small-16 columns" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
      <div className="row columns">
        <div className="comparison-table">
          <table className="text-center">
            <thead>
              <tr>
                <td width="50%"/>
                <td width="25%">
                  <h3 dangerouslySetInnerHTML={{ __html: first(comparing) }}/>
                </td>
                <td width="25%">
                  <h3 dangerouslySetInnerHTML={{ __html: last(comparing) }}/>
                </td>
              </tr>
            </thead>
            <tbody>
            {restRows.map((columns, key) => {
              const one = idx(columns, _ => _[0]) || '';
              const two = idx(columns, _ => _[1]) || '';
              const three = idx(columns, _ => _[2]) || '';
              const four = idx(columns, _ => _[3]);

              return (
                <tr key={key}>
                  <td>
                    <span dangerouslySetInnerHTML={{ __html: one }}/>
                    { four && <div className="tooltip-wrapper">
                      <i className="fa fa-question-circle" data-tip={true} data-for={`tooltip-${key}`}
                        data-event={isMobile()? "click" : undefined} />
                      <Tooltip class="tooltip" effect="solid" place="right" id={`tooltip-${key}`}>
                        <span dangerouslySetInnerHTML={{ __html: four }}/>
                      </Tooltip>
                    </div> }
                  </td>
                  <td dangerouslySetInnerHTML={{ __html: two }}/>
                  <td dangerouslySetInnerHTML={{ __html: three }}/>
                </tr>);
            })}
            </tbody>
          </table>
        </div>
      </div>
    </section>);
};

Comparison.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  rows_html: PropTypes.array,
  background: PropTypes.string
};

export default Comparison;



// WEBPACK FOOTER //
// ./landing_pages/components/comparison.jsx